// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2y-N5","title":"card_title__1fPPT","inActive":"card_inActive__3sZcD"};